export default __webpack_public_path__ + "static/6-3--286571e71fc370a74834c989539724e8.png";